<template>
  <div class="group group--sidebar group--query query pab2">
    <h1 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h1 group__title mb0">Request an Appointment Slot</h1>
    <p class="p group__description">Complete the form to send your appointment request</p>
    <ui-auth
      id="appointmentQuery"
    />
  </div>
</template>

<script>

// Vuex
import { mapGetters, mapActions } from 'vuex';

// 3rd party
import moment from 'moment';

// Modules
import UiAuth from 'components/Auth';

export default {
  name: 'view-query',

  components: {
    UiAuth,
  },

  // Data
  data() {
    return {
      dateToRequest: moment().format(),
    };
  },

  computed: {
    ...mapGetters('provider', ['provider']),
    ...mapGetters('app', ['org']),
  },

  // Methods
  methods: {
    ...mapActions('provider', ['getProviderDetail']),
  },

  // Lifecycles

  created() {
    if ( !this.provider) {
      this.$router.push({ name: 'results' });

      return;
    }
    this.getProviderDetail(this.dateToRequest);
  },
};
</script>



// WEBPACK FOOTER //
// Query.vue?52ce2d7a